<template>
  <main>
    <template v-if="shouldShowExpiringPointsNotify && !hasRewardsDisabled">
      <div class="message is-warning livelo-notify">
        <div class="message-body">
          <p>
            Você tem {{ user.rewards.points_expiring }} Pratas que irão vencer em
            {{ user.rewards.points_expiring_at }}.
            <a @click="goToLiveloStatement">Clique aqui</a>
            e transfira seus pontos agora.
          </p>
        </div>
      </div>
    </template>

    <template v-if="hasTitle">
      <div class="columns mt-5 is-gapless">
        <div class="column header">
          <h1 class="custom-title mt-0">
            {{ title }}

            <slot name="addOnTitle" />
          </h1>
          <p v-if="subtitle" class="custom-subtitle">
            {{ subtitle }}
          </p>
        </div>
        <div class="column is-narrow ml-auto">
          <slot name="actions" />
        </div>
      </div>
    </template>

    <slot name="message" />

    <slot name="helper" />

    <template v-if="isCard">
      <div
        class="card"
        :style="`--max-width:${maxWidth}`"
      >
        <div class="card-content">
          <slot />
        </div>
      </div>
    </template>

    <slot v-else />

    <div v-if="showLiveloModal && !hasRewardsDisabled">
      <LoginNotifyLiveloModal
        v-if="!shouldStopShowingLoginLiveloModal
          && user?.rewards?.points_available_to_transfer >= 1000
          && user?.rewards?.points_expiring"
        @close="showLiveloModal = false"
      />

      <TransferNotifyLiveloModal
        v-else-if="!shouldStopShowingTransferLiveloModal
          && user?.rewards?.points_available_to_transfer >= 1000
        "
        @close="showLiveloModal = false"
      />
    </div>

    <FirstSaleAchievementModal
      v-if="firstSaleAchievementId"
      :achievement-id="firstSaleAchievementId"
      @close="firstSaleAchievementId = null"
    />

    <portal-target
      multiple
      name="mobile-actions"
    />
  </main>
</template>

<script>
import { mapState } from 'vuex';

import LoginNotifyLiveloModal from '@/components/LoginNotifyLiveloModal.vue';
import TransferNotifyLiveloModal from '@/components/TransferNotifyLiveloModal.vue';
import FirstSaleAchievementModal from '@/components/achievements/FirstSaleAchievementModal.vue';
import notificationActionBus from '@/utils/notificationActionBus';

export default {
  name: 'Layout',
  components: {
    LoginNotifyLiveloModal,
    TransferNotifyLiveloModal,
    FirstSaleAchievementModal,
  },
  props: {
    isCard: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxWidth: {
      type: String,
      required: false,
      default: '800px',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: () => ({
    showLiveloModal: true,
    firstSaleAchievementId: null,
  }),
  computed: {
    ...mapState({
      user: (state) => state.user.userInfo,
    }),

    // livelo
    shouldStopShowingTransferLiveloModal() {
      const toValidate = window.localStorage.getItem('shouldStopShowingTransferLiveloModal');
      const currentRoute = this.$route.name;
      return (/true/).test(toValidate) || currentRoute === 'livelo-statement';
    },
    shouldStopShowingLoginLiveloModal() {
      const toValidate = window.localStorage.getItem('shouldStopShowingLoginLiveloModal');
      const currentRoute = this.$route.name;
      return (/true/).test(toValidate) || currentRoute === 'livelo-landing-page';
    },
    expiringPoints() {
      return Number(this.user?.rewards?.points_expiring || 0);
    },
    shouldShowExpiringPointsNotify() {
      if (this.$route.name.includes('livelo-statement')) return false;

      if (this.$route.name.includes('hub')) return false;

      return this.expiringPoints > 1000;
    },
    hasRewardsDisabled() {
      return this.user?.rewards_disabled || false;
    },

    // content
    hasTitle() {
      return !!this.title;
    },
  },
  mounted() {
    // B2B-320: clique na notificação "🏆 Primeira venda" (data.action='action')
    // emite este evento no bus global — ver TheNotifications.vue@onClick.
    notificationActionBus.$on('open_first_sale_achievement_modal', this.handleOpenFirstSaleAchievement);
  },
  beforeDestroy() {
    notificationActionBus.$off('open_first_sale_achievement_modal', this.handleOpenFirstSaleAchievement);
  },
  methods: {
    // livelo
    goToLiveloStatement() {
      this.$router.push({ name: 'livelo-statement' });
    },

    // achievements (B2B-320)
    handleOpenFirstSaleAchievement({ achievement_id: achievementId }) {
      this.firstSaleAchievementId = achievementId;
    },
  },
};
</script>

<style lang="scss" scoped>
.livelo-notify {
  margin-top: 24px;
}

.custom-header {
  margin-top: 2rem;
}

.custom-title {
  font: {
    family: Inter;
    size: 24px;
    weight: 500;
  }
  text: {
    underline-position: from-font;
    decoration-skip-ink: none;
  }
  line-height: 36px;
  color: #4a4a4a;
}

.custom-subtitle {
  font: {
    family: Inter;
    size: 14px;
    weight: 400;
  }
  color: #4a4a4a;
}

.card {
  margin-top: 30px;
  box-shadow: 0 1px 1px 1px rgba(10, 10, 10, 0.1);
}

.column.is-narrow.ml-auto {
  display: flex;
  gap: 16px;
}
</style>
